import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Hero from "../../components/PP/Hero";
import Description from "../../components/PP/Description";

const PrivacyPolicy = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const viewportHeight = window.innerHeight;

      if (scrollPosition > 0.2 * viewportHeight) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div id="PrivacyPolicy">
      <Header isScrolled={isScrolled} />
      <Hero />
      <Description />
    </div>
  );
};

export default PrivacyPolicy;
